import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const Plus: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  viewBox = '0 0 50 50',
  d = 'M50 28.6H28.6V50h-7.1V28.6H0v-7.2h21.5V0h7.1v21.4H50z',
  transition = 'fill 0.1s ease-in-out',
  cssHelper = Styling.fullWidthStyle,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      cssHelper={cssHelper}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path fill={fill} d={d} transition={transition} />
    </Elements.Svg>
  );
};

export default Plus;
